/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_SubtitleInputs */

const cs_reports_subtitle = /** @type {(inputs: Reports_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KPI, zdroje leadů, kampaně a výkon makléřů.`)
};

const en_reports_subtitle = /** @type {(inputs: Reports_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KPIs, lead sources, campaigns and agent performance.`)
};

/**
* | output |
* | --- |
* | "KPIs, lead sources, campaigns and agent performance." |
*
* @param {Reports_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_subtitle = /** @type {((inputs?: Reports_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_subtitle(inputs)
	return cs_reports_subtitle(inputs)
});